import { useTranslation } from 'react-i18next';
import { Button } from '@scio3/ui';
import { Headset, ChevronDown, ChevronUp } from 'lucide-react';
import { useOptibotStore } from '../stores/optibot-store';
import { SupportInfo } from './SupportInfo';

/**
 * Contact-support callout pinned at the top of the chat (below the header). It
 * never disappears — the toggle collapses it between a compact one-line form
 * (headset + label) and the full two-line details (phone / email / hours).
 */
export function SupportCallout() {
  const { t } = useTranslation();
  const supportCollapsed = useOptibotStore((s) => s.supportCollapsed);
  const setSupportCollapsed = useOptibotStore((s) => s.setSupportCollapsed);

  return (
    <div className="shrink-0 bg-card px-3 pt-3 pb-1">
      <div className="rounded-lg bg-muted px-3 py-2">
        {supportCollapsed ? (
          // Collapsed: a single clickable row that expands back to the full details.
          <button
            type="button"
            onClick={() => setSupportCollapsed(false)}
            aria-label={t('optibot.expandSupport')}
            className="flex w-full cursor-pointer items-center gap-2.5 text-left"
          >
            <Headset className="h-4 w-4 shrink-0 text-primary" />
            <span className="flex-1 truncate text-xs font-medium text-foreground">
              {t('optibot.contactSupport')}
            </span>
            <ChevronDown className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
          </button>
        ) : (
          <div className="relative pr-6">
            <SupportInfo />
            <Button
              variant="ghost"
              size="icon-xs"
              onClick={() => setSupportCollapsed(true)}
              aria-label={t('optibot.collapseSupport')}
              className="absolute right-0 top-0 cursor-pointer text-muted-foreground hover:text-foreground"
            >
              <ChevronUp className="h-3.5 w-3.5" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
